if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.addEventListener('change', this.onVariantChange);

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = this.closest('.thb-product-detail').querySelector('.product-images'),
        thumbnails = this.closest('.thb-product-detail').querySelector('#Product-Thumbnails');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {

        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return ['js-variant-price', 'js-variant-inventory', 'js-variant-sku', 'js-variant-cta-price'];
    }

    renderProductInfo() {
      const targets = this.getSectionsToRender();
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          // Scope to this section so a second product section on the page isn't touched
          const section = this.closest('.shopify-section') || document;

          targets.forEach((className) => {
            const destinations = section.querySelectorAll(`.${className}`);
            const sources = html.querySelectorAll(`.${className}`);

            // Paired by document order, so a class can mark more than one element
            destinations.forEach((destination, index) => {
              const source = sources[index];

              destination.innerHTML = source ? source.innerHTML : '';
              destination.classList.remove('visibility-hidden');
            });
          });
          this.syncAddToCartState(html);
        });
    }

    // The button's state is decided in Liquid (stock levels, stock already in the
    // cart, whether the cross-sell modal opener takes the button's place), so mirror
    // the freshly rendered section instead of re-deriving it from the variant JSON
    syncAddToCartState(html) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const holder = productForm.querySelector('.add_to_cart_holder');
      const sourceHolder = html.querySelector('.add_to_cart_holder');
      if (!holder || !sourceHolder) return;

      const addButton = holder.querySelector('[name="add"]');
      const sourceAddButton = sourceHolder.querySelector('[name="add"]');
      // The cross-sell opener is only rendered for a variant that can be bought
      const opener = holder.querySelector('modal-opener');
      const openerIsAvailable = sourceHolder.querySelector('modal-opener') !== null;

      if (addButton && sourceAddButton) {
        const addButtonText = holder.querySelector('[name="add"] > span');
        const sourceAddButtonText = sourceHolder.querySelector('[name="add"] > span');

        if (addButtonText && sourceAddButtonText) {
          addButtonText.textContent = sourceAddButtonText.textContent.trim();
        }
        addButton.classList.toggle('sold-out', sourceAddButton.classList.contains('sold-out'));
        addButton.classList.toggle('all-stock-in-cart', sourceAddButton.classList.contains('all-stock-in-cart'));
        addButton.classList.remove('loading');
        addButton.disabled = sourceAddButton.hasAttribute('disabled');
        // Liquid hides the button with an inline style when the cross-sell opener replaces
        // it, so only hide it while there is an opener in the DOM to stand in for it
        addButton.style.display = opener && openerIsAvailable ? 'none' : '';
      }

      if (opener) {
        // Hide the opener again when the customer moves to a sold out variant
        opener.style.display = openerIsAvailable ? '' : 'none';

        const openerButton = opener.querySelector('button');
        if (openerButton) openerButton.disabled = !openerIsAvailable;
      }
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      // Stands in for the add to cart button while the cross-sell modal is enabled
      const crossSellOpenerButton = productForm.querySelector('.add_to_cart_holder modal-opener button');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (crossSellOpenerButton) crossSellOpenerButton.disabled = true;
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('loading');
        if (crossSellOpenerButton) crossSellOpenerButton.disabled = false;
        addButtonText.textContent = window.theme.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const section = this.closest('.shopify-section') || document;
      const prices = section.querySelectorAll('.js-variant-price');
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add('sold-out');
      prices.forEach((price) => price.classList.add('visibility-hidden'));
      section.querySelectorAll('.js-variant-cta-price').forEach((price) => (price.textContent = ''));
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
    updateVariantText() {


    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      }
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };

      if (this.classList.contains('product-quick-images')) {
        this.options.cellAlign = 'left';
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.flkty.on('settle', function (index) {
        this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {
        let previous_slide = this.flkty.cells[this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector('.product-single__media'),
          active_thumb = false;

        if (this.thumbnail_container) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');
        }

        requestAnimationFrame(() => {
          if (active_thumb) {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          }

        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector("video").pause();
        }

        // Draggable.
        if (media.classList.contains('product-single__media-model')) {
          this.setDraggable(false);
        } else {
          this.setDraggable(true);
        }
      });

      if (this.thumbnail_container) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
        });
      }
      let scrollbar = document.querySelector('.product-quick-images__scrollbar>div');

      if (scrollbar) {
        this.flkty.on('scroll', function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = 'scaleX(' + progress + ')';
        });
      }

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.quantityAvailable = this.dataset.quantityAvailable

      if (this.quantityAvailable) {
        this.form.querySelector('[type="submit"]').disabled = true;
        this.form.querySelector('[type="submit"]').innerHTML = `<span>${window.theme.variantStrings.addedToCart}</span>`;
        document.querySelector('.spp2__widget.spp2__widget_installment').style.display = 'none';
      }

      this.hideErrors = this.dataset.hideErrors === 'true';


    }
    async onSubmitHandler(evt) {
      evt.preventDefault();

      //Needed or the function doesn't work properly on FF (the cart fetch in 'getFreeShippingHollowProductStatus' seems to fail which makes hollowProductStatus falsy and throw an error which doesn't happen on any other browsers)
      if (typeof evt.stopImmediatePropagation === 'function') {
        evt.stopImmediatePropagation();
      }
      evt.stopPropagation();

      if (!this.form.reportValidity()) {
        return;
      }
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      const formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      const productTitleEle = document.querySelector(`#ProductInfo-${formData.get('section-id')} .product-title`);

      //Arr of products being added in this request - Used in getFreeShippingHollowProductStatus to work out if the layaway hollow product should be added
      let productsBeingAdded = [];

      let additionalItemsInCartCount = 0;

      // Boolean indicating if the customer has requested a resize
      const resizeRequested = formData.get('properties[Requested resize]');
      //'Increase', 'Decrease' or null
      const resizeType = formData.get('properties[_Resize type]');

      const resizingInput = document.querySelector('[data-resize-type]');

      const isRingResizingFree = document.querySelector('product-resize')?.dataset?.f === 'true';
      //If customer has requested a resize,  selected a size other than the ring's current size, and the resizing isn't free..
      if (resizeRequested && !resizeRequested.includes('Original size') && resizingInput && !isRingResizingFree) {
        let hollowVariantId;

        const resizingProductBeingAdded = {};

        //Get the resizing hollow product's id and price
        if (resizeType === 'Increase') {
          hollowVariantId = resizingInput.dataset.increaseVariantId;
          resizingProductBeingAdded.final_price = parseInt(resizingInput.dataset.increaseVariantPrice);
        } else {
          hollowVariantId = resizingInput.dataset.decreaseVariantId;
          resizingProductBeingAdded.final_price = parseInt(resizingInput.dataset.decreaseVariantPrice);
        }
        resizingProductBeingAdded.variant_id = parseInt(hollowVariantId);
        productsBeingAdded.push(resizingProductBeingAdded);

        //Add ring resizing hollow product to the cart while adding the parent product
        formData.append(`items[${additionalItemsInCartCount}][id]`, hollowVariantId);
        formData.append(`items[${additionalItemsInCartCount}][quantity]`, 1);
        formData.append(`items[${additionalItemsInCartCount}][properties][_add-on]`, true);
        //Official way to remove add-on item if its parent item is removed
        formData.append(`items[${additionalItemsInCartCount}][parent_id]`, parseInt(formData.get('id')));
        //Our old way to remove add-on item if its parent item is removed which might as well be kept
        formData.append(`items[${additionalItemsInCartCount}][properties][_parent-item-variant-id]`, formData.get('id'));
        additionalItemsInCartCount++;
      }

      //If customer is also purchasing items from the cross-sell modal
      const crossSellModalInputs = document.querySelectorAll('.cross-sell-modal[open] .cross-sell-modal__card-input');
      if (crossSellModalInputs.length > 0) {
        crossSellModalInputs.forEach((input) => {
          if (input.checked) {
            formData.append(`items[${additionalItemsInCartCount}][id]`, input.dataset.variantId);
            formData.append(`items[${additionalItemsInCartCount}][quantity]`, 1);
            //Used to remove add-on item if its parent item is removed
            //Official way to remove add-on item if its parent item is removed
            formData.append(`items[${additionalItemsInCartCount}][parent_id]`, parseInt(formData.get('id')));
            //Our old way to remove add-on item if its parent item is removed which might as well be kept
            formData.append(`items[${additionalItemsInCartCount}][properties][_parent-item-variant-id]`, formData.get('id'));
            
            if (productTitleEle && productTitleEle.textContent) {
              formData.append(`items[${additionalItemsInCartCount}][properties][_For]`, productTitleEle.textContent);
            }
            //Add cross-sell product to the array of items being added during this request, so its cost can be taken into account as to whether the free shipping hollow product needs to be added 
            const variantId = parseInt(input.dataset.variantId, 10);
            if (!Number.isNaN(variantId)) {
              productsBeingAdded.unshift({
                variant_id: variantId,
                final_price: parseInt(input.dataset.price, 10)
              });
            }
            additionalItemsInCartCount++;
          }
        });
      }

      //If possible, get the details of the product being added so we can calculate if the free shopping product should be added at the same time as the parent product
      const priceElement = document.querySelector('.product [data-price]');
      const priceOfProductBeingAdded = priceElement ? parseInt(priceElement.dataset.price) : null;
      let standardProductBeingAdded = {};
      let freeShippingHollowProductAddedToCart = false;
      let hollowProductStatus;
      if (priceOfProductBeingAdded && !isNaN(priceOfProductBeingAdded)) {
        standardProductBeingAdded.final_price = priceOfProductBeingAdded;
        standardProductBeingAdded.variant_id = parseInt(formData.get('id'));
        if (formData.get(`properties[${window.theme.layawayText}]`)) {
          standardProductBeingAdded.properties = {};
          standardProductBeingAdded.properties[window.theme.layawayText] = formData.get(`properties[${window.theme.layawayText}]`);
        }
        productsBeingAdded.push(standardProductBeingAdded);

        hollowProductStatus = await getFreeShippingHollowProductStatus({ productsBeingAdded: productsBeingAdded });

        // if free shipping product isn't in the cart and should be
        if (!hollowProductStatus?.keyForHollowProductInCart && hollowProductStatus.shouldBeInCart === true) {
          //add it to the cart while adding the parent product  
          formData.append(`items[${additionalItemsInCartCount}][id]`, window.theme.freeShippingHollowVariantId);
          formData.append(`items[${additionalItemsInCartCount}][quantity]`, 1);
          formData.append(`items[${additionalItemsInCartCount}][properties][_add-on]`, true);
          freeShippingHollowProductAddedToCart = true;
          additionalItemsInCartCount++;
        }
      }

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          dispatchCustomEvent('product:added-to-cart');

          /**@todo Need to re-render the product form so it reflects the new item quantities */
          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(async () => {
          //If the hollow product was just added to the cart, we don't need to check if it needs to be removed
          if (!freeShippingHollowProductAddedToCart) {
            if (!hollowProductStatus) {
              hollowProductStatus = await getFreeShippingHollowProductStatus();
            }
            // If the hollow product was already in the cart and should be removed, remove it
            if (hollowProductStatus?.keyForHollowProductInCart && hollowProductStatus?.shouldBeInCart === false) {
              await removeFreeShippingHollowProduct(hollowProductStatus.keyForHollowProductInCart);
            }
          }
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.form.querySelector('[type="submit"]').disabled = true;
          this.form.querySelector('[type="submit"]').innerHTML = `<span>${window.theme.variantStrings.addedToCart}</span>`;
          document.querySelector('.spp2__widget.spp2__widget_installment').style.display = 'none';
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');

        if (!document.getElementById('Cart-Drawer')) {
          this.body.classList.remove('open-cc');
        }
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 * 
 * Product offer
 */
if (!customElements.get('product-offer')) {
  customElements.define('product-offer', class ProductOffer extends HTMLElement {
    constructor() {
      super();
      this.trigger = document.querySelector('[data-product-offer-promo-trigger]');
      this.close = document.querySelector('[data-product-offer-promo-close]');
      this.overlay = document.querySelector('[data-product-offer-promo-overlay]');
      this.modal = document.querySelector('[data-product-offer-promo-modal]');
      this.message = document.querySelector('[data-product-offer-promo-message]');

      this.openStatus = false;

      if (!this.trigger || !this.close || !this.overlay || !this.modal || !this.message) {
        return;
      }

      if (window.location.search.includes('contact_posted=true')) {
        this.message.innerText = 'Thank you for your offer! We will get back to you as soon as possible.';
        this.message.scrollIntoView();
      }

      this.trigger.addEventListener('click', () => {
        this.toggle('open');
      });

      this.close.addEventListener('click', () => {
        this.toggle('close');
      });

      this.overlay.addEventListener('click', () => {
        this.toggle('close');
      });

      // Hide when ESC is pressed
      document.addEventListener('keydown', event => {
        if (event.key == 'Escape' && this.openStatus) {
          this.toggle('close');
        }
      }, false);

      // form handling
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-button-type="submit"]');
      this.button.addEventListener('click', (event) => this.checkOffer(event));
    }

    toggle(action) {
      if (action == 'open') {
        this.openStatus = true;
        document.body.classList.add('body--no-scroll');
        this.modal.classList.add('active');
        this.overlay.classList.add('active')
        this.modal.removeAttribute('aria-hidden');
        this.overlay.removeAttribute('aria-hidden');
      }

      if (action == 'close') {
        this.openStatus = false;
        document.body.classList.remove('body--no-scroll');
        this.modal.classList.remove('active');
        this.overlay.classList.remove('active')
        this.modal.setAttribute('aria-hidden', true);
        this.overlay.setAttribute('aria-hidden', true);
      }
    }

    checkOffer(event) {
      event.preventDefault();
      var form = this.form;
      var offer = parseFloat(form.querySelector('input[name="contact[offer]"]').value);
      var price = parseFloat(form.querySelector('input[name="contact[product_price]"]').value) / 100;
      var percentage = parseFloat(form.querySelector('input[name="contact[product_low]"]').value) / 100;
      var lowest = price * percentage;

      if (offer >= lowest) {
        form.querySelector('.rejection-message').classList.add('is-hidden');
        form.reportValidity();
        if (form.reportValidity()) {
          form.submit();
        }
      } else {
        form.reportValidity();
        form.querySelector('.rejection-message').classList.remove('is-hidden');
      }
      return false;
    }

  });
}

if (!customElements.get('cross-sell-modal')) {
  customElements.define('cross-sell-modal', class CrossSellModal extends HTMLElement {
    constructor() {
      super();
      this.contentInfo = this.querySelector('.product-popup-modal__content-info')
      this.addToCart = this.querySelector('#cross-sell-modal__add-to-cart');
      this.noThanks = this.querySelector('#cross-sell-modal__no-thanks');
      this.modalButtons = [this.addToCart, this.noThanks];
      this.crossSellModalInputs = this.querySelectorAll('.cross-sell-modal__card-input');
      this.formNotification = this.querySelector('.form-notification');
      this.errorMsg = this.formNotification.querySelector('.product-form__error-message');

      this.productFormEle = document.querySelector('product-form.product-form form');

      document.addEventListener('modal:closing', (event) => {
        if (!event.detail.modal.classList.contains('cross-sell-modal')) return;
        this.submitProductForm(false);
      });

      this.modalButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const isCrossSellRequested = button == this.noThanks ? false : true;
          this.submitProductForm(isCrossSellRequested);
        });
      });
      this.crossSellModalInputs.forEach((input) => {
        //Hide error message if an input is selected
        input.addEventListener('change', () => {
          this.formNotification.hidden = true;
          if (this.errorMsg) this.errorMsg.textContent = '';
        });
      });
    }

    submitProductForm(isCrossSellRequested) {
      if (!this.productFormEle) return;

      const someInputsChecked = [...this.crossSellModalInputs].some((input) => input.checked == true)

      //Hide any previous errors
      this.formNotification.hidden = true;
      if (this.errorMsg) this.errorMsg.textContent = '';

      //If the user has said no to the cross-sells, uncheck the cross-sell products so they aren't added to cart
      if (!isCrossSellRequested && someInputsChecked) {
        this.crossSellModalInputs.forEach((input) => {
          input.checked = false;
        })
      }

      //If the user has said yes to cross-sells, but not selected any cross-sell products, show an error
      if (isCrossSellRequested && !someInputsChecked) {
        if (this.errorMsg) {
          const errorUiText = this.errorMsg.dataset.selectErrorText;
          if (errorUiText) {
            this.errorMsg.textContent = errorUiText;
            this.formNotification.hidden = false;
          }
        }
        return;
      }

      const submitEvent = typeof SubmitEvent === 'function'
        ? new SubmitEvent('submit', { bubbles: true, cancelable: true })
        : new Event('submit', { bubbles: true, cancelable: true });
      this.productFormEle.dispatchEvent(submitEvent);
      if (this.contentInfo) this.contentInfo.classList.add('loading');
      this.setAttribute('aria-disabled', true);
      /**@todo If successful, need to hide modal (And re-render .add_to_cart_holder so customer isn't able to add multiple of same product) */
    }

    //Listening for when the updating the cart is successful or fails
    connectedCallback() {
      document.addEventListener('product:variant-error', (event) => {
        if (this.contentInfo) this.contentInfo.classList.remove('loading');
        this.formNotification.querySelector('.product-form__error-message').textContent = event.detail.message;
        this.formNotification.hidden = false;
      });

      // fetch(window.Shopify.routes.root + "?sections={section-id}")

      document.addEventListener('product:added-to-cart', () => {
        if (this.contentInfo) this.contentInfo.classList.remove('loading');
        document.body.classList.remove('overflow-hidden');
        if (document.querySelector('modal-dialog.cross-sell-modal[open]'))
          document.querySelector('modal-dialog.cross-sell-modal[open]').removeAttribute('open');
      });
    }
  });
}

if (!customElements.get('cross-sell-card')) {
  customElements.define('cross-sell-card', class CrossSellCard extends HTMLElement {
    constructor() {
      super();

      // DOM references
      this.selects = this.querySelectorAll('select');
      this.idInput = this.querySelector('input');
      this.productId = this.dataset.id;
      this.variantImg = this.querySelector('img');
      this.variantPrice = this.querySelector('.single-price .money') || this.querySelector('.price ins .money') || this.querySelector('.price ins .amount');
      this.variantCompareAtPrice = this.querySelector('.price del .money');
      this.variantData = window[`crossSellProduct${this.productId}`]?.variants;

      // Guard clause
      if (!this.selects.length || !this.idInput || !this.productId || !this.variantData) return;

      // Initialize
      this.init();
    }

    init() {
      // Listen for changes
      this.selects.forEach(select => {
        select.addEventListener('change', this.updateVariant.bind(this));
      });
    }

    updateVariant() {
      const selectedOptions = Array.from(this.selects).map(select => select.value);

      const matchedVariant = this.variantData.find(variant => {
        return selectedOptions.every((value, index) => {
          return variant[`option${index + 1}`] === value;
        });
      });

      if (!matchedVariant || !this.variantPrice || !this.idInput) return;
      this.idInput.dataset.variantId = matchedVariant.id;
      this.idInput.value = matchedVariant.id;

      this.idInput.dataset.price = matchedVariant.price;
      const priceInCurrency = (matchedVariant.price / 100).toFixed(2);
      const priceFormatted = new Intl.NumberFormat(window.Shopify.locale, {
        style: 'currency',
        currency: window.Shopify.currency.active
      }).format(priceInCurrency);
      this.variantPrice.textContent = priceFormatted;

      if (this.variantCompareAtPrice) {
        if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
          const compareAtPriceInCurrency = (matchedVariant.compare_at_price / 100).toFixed(2);
          const compareAtPriceFormatted = new Intl.NumberFormat(window.Shopify.locale, {
            style: 'currency',
            currency: window.Shopify.currency.active
          }).format(compareAtPriceInCurrency);
          this.variantCompareAtPrice.textContent = compareAtPriceFormatted
        } else {
          this.variantCompareAtPrice.textContent = ""
        }
      }

      if (!this.variantImg || !matchedVariant.featured_image || !matchedVariant.featured_image.src) return;
      this.variantImg.src = matchedVariant.featured_image.src + '&width=150&height=150';
      this.variantImg.srcset = ""
    }
  });
}